import { isAfter, subYears } from 'date-fns';

export const getTime = (timeStampSec: string) => {
  return new Date(parseInt(timeStampSec) * 1000);
};

/**
 * Get the minimum time from an array of timestamp second
 *
 * @returns The minimum time: Date | null (if array is empty)
 *
 * @param timestampSecList: Array<number as string>
 */
export const getMinimumTime = (timestampSecList: string[]): Date | null => {
  if (timestampSecList.length === 0) return null;
  let minimumTime = new Date();
  minimumTime.setHours(23, 59, 59);
  timestampSecList.forEach((timestampSec) => {
    // convert to Date format
    const currentTime = new Date(parseInt(timestampSec) * 1000);
    if (currentTime < minimumTime) minimumTime = currentTime;
  });
  return minimumTime;
};

/**
 *
 * @param birthday The birthday in string format (YYYY-MM-DD)
 */
export const isOver18YearOld = (birthday: string) => {
  const currentDate = new Date();
  return !isAfter(new Date(birthday), subYears(currentDate, 18));
};

export const getExpireTime = (duration: number) => {
  const currentTime = new Date().getTime();
  const expireTime = new Date(currentTime + duration).toUTCString();

  return expireTime;
};
